// extracted by mini-css-extract-plugin
export default {"title":"E57GKlsNT6ZWwWKoy3uo"};